import { useErgonomicsContext } from "../../../contexts/ErgonomicsContext";
import { Panel } from "../../../components/panels/Panel";
import { ErgonomicsCard } from "../../ergonomics/components/ErgonomicsCard";
import { ErgonomicsCardData } from "../../ergonomics/components/cards/ErgonomicsCardData";
import { ErgonomicsCardDataRequest } from "../../ergonomics/components/cards/ErgonomicsCardDataRequest";
import { ErgonomicsFatigueIndex } from "../../ergonomics/components/ErgonomicsFatigueIndex";
import { Loader } from "../../../components/loading/Loader";
import { ErgonomicsCardDataGraph } from "../../ergonomics/components/cards/ErgonomicsCardDataGraph";


export const ErgonomicsDashboardContent = () => {

  const { isLoading } = useErgonomicsContext();

  return (
    <Panel title="TABLEAU DE BORD" category="main">
      {isLoading && <Loader category="transparent"/>}
      <div className="h-full flex flex-col items-start gap-4">
        {/* Top block */}
        <div className="w-full min-h-[400px] h-full">
          <ErgonomicsCard>
            <ErgonomicsCardDataGraph/>
          </ErgonomicsCard>
        </div>

        {/* Bottom blocks */}
        <div className="flex gap-4 pb-4">
          {/* Left column */}
          <div className="w-full flex flex-col gap-4">
            <div className="w-full">
              <ErgonomicsCard>
                <ErgonomicsCardDataRequest showWorkstationSelector={true}/>
              </ErgonomicsCard>
            </div>
            <div className="">
              <ErgonomicsCard>
                <ErgonomicsFatigueIndex showWorkstationSelector={true} forceLastDay={true} showPanel={true}/>
              </ErgonomicsCard>
            </div>
          </div>

          {/* Right column */}
          <div className="flex flex-col gap-4 w-full">
            <div className="h-full">
              <ErgonomicsCard>
                <ErgonomicsCardData forceLastDay={false}/>
              </ErgonomicsCard>
            </div>
          </div>
        </div>
      </div>
    </Panel>
  );
};